export const TableHead = [
  "Estate Name",
  "Estate Address",
  "Phone Number",
  "Email Address",
  "Action",
];
